/**
 * 쿠키 키 상수
 */
export const COOKIE_KEYS = {
  /** 테마 모드 (light | dark) */
  THEME_MODE: 'doddies-theme-mode',
  /** 화면 모드 (desktop | mobile) — 없으면 화면 폭이 정한다. */
  VIEW_MODE: 'doddies-view-mode',
} as const;
